import React from "react";
import { useNavigate } from "react-router-dom";
import useSeo from "../seo/useSeo";
import useJsonLd from "../seo/useJsonLd";

function Card({ title, desc, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        width: "100%",
        textAlign: "left",
        background: "#fff",
        border: "1px solid #e6e6e6",
        borderRadius: 14,
        padding: 16,
        cursor: "pointer",
      }}
    >
      <div style={{ fontWeight: 800, fontSize: 16, color: "#222" }}>
        {title}
      </div>
      <div
        style={{ marginTop: 6, color: "#666", fontSize: 13, lineHeight: 1.4 }}
      >
        {desc}
      </div>
      <div style={{ marginTop: 10, color: "#4caf50", fontWeight: 700 }}></div>
    </button>
  );
}

export default function FusionPage() {
  const navigate = useNavigate();

  useSeo({
    title: "Fusion PDF & Images – Regrouper des fichiers | pdf-convert.fr",
    description:
      "Fusionnez plusieurs PDF en un seul fichier, ou regroupez plusieurs images (JPG/PNG) en un PDF. Gratuit, rapide, 100% local.",
    canonical: "https://pdf-convert.fr/fusion",
  });

  useJsonLd("breadcrumb-fusion", {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Accueil",
        item: "https://pdf-convert.fr/home",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Fusion",
        item: "https://pdf-convert.fr/fusion",
      },
    ],
  });

  return (
    <main style={{ maxWidth: 900, margin: "0 auto", padding: 16 }}>
      <h1 style={{ textAlign: "center" }}>Fusionner des fichiers PDF</h1>
      <p style={{ textAlign: "center", color: "#666", marginTop: 6 }}>
        Choisis l’opération de fusion que tu veux faire.
      </p>

      <div
        style={{
          marginTop: 18,
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: 14,
        }}
      >
        <Card
          title="Fusionner plusieurs PDF → 1 PDF"
          desc="Dépose plusieurs PDF, réorganise l’ordre, puis télécharge un PDF final."
          onClick={() => navigate("/fusion-pdf")}
        />

        <Card
          title="Fusionner plusieurs JPG/PNG → 1 PDF"
          desc="Dépose plusieurs images, réorganise l’ordre, et génère un PDF A4 optimisé."
          onClick={() => navigate("/fusion-jpg-pdf")}
        />

        <Card
          title="Supprimer / Réordonner des pages (PDF)"
          desc="Supprime des pages, réorganise l’ordre, et génère un PDF A4 optimisé."
          onClick={() => navigate("/edition-pages-pdf")}
        />
        <Card
          title="Extraire des pages PDF"
          desc="Sélectionner et extraire des pages spécifiques d’un PDF pour créer un nouveau fichier."
          onClick={() => navigate("/split-pdf")}
        />
      </div>
    </main>
  );
}
